import React from "react";
import styled from "styled-components";

//
import BGIMG from "../../../assets/images/single-service-doctor.jpg";

export default function SingleServiceCEO() {
  return (
    <StyledSingleServiceCEO>
      <div className="container">
        <div className="single-service-ceo__wrap">
          <div className="single-service-ceo__card">
            <h1>
              Our optometric team is ready to look after all your eye emergency
              needs. Take care of your eye health!
            </h1>
            <div>
              <b>Dr. Zella Koelpin</b>
              <p>Anaesthesist</p>
            </div>
          </div>
        </div>
      </div>
    </StyledSingleServiceCEO>
  );
}

const StyledSingleServiceCEO = styled.section`
  background-image: url(${BGIMG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 140px 0;

  .single-service-ceo {
    &__wrap {
    }

    &__card {
      background-color: var(--dark-blue);
      max-width: 550px;
      margin-left: auto;
      padding: 60px;

      h1 {
        color: var(--white);
        font-size: var(--fs-card-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: 1.35;
        margin-bottom: 32px;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        b {
          color: var(--white);
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 26px;
        }

        p {
          color: var(--white);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 146.667% */
          opacity: 0.75;
        }
      }
    }
  }
`;
